import { useEffect, useState } from 'react'
import { Spacer } from '@jisr-hr/ds'
import { ViewedComponent } from 'components/authorised/Performace'
import { DatePicker } from '@jisr-hr/design-system'
import { format } from 'date-fns'
import FilterBoxHeader from '../FilterBox/FilterBoxHeader'
import { useFilters } from './context'

type DateProps = {
  end: Date
  start: Date
}

const Duration = (): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [startEndDate, setStartEndDate] = useState<DateProps>()

  const { filter, handleFilter } = useFilters()

  const handleChangeDate = (_: unknown, { start, end }: DateProps): void => {
    if (end && start) {
      setStartEndDate({ start, end })
      handleFilter('duration', {
        from: format(start, 'yyyy-MM-dd'),
        to: format(end, 'yyyy-MM-dd'),
      })
    } else {
      setStartEndDate({ start, end })
    }
  }

  useEffect(() => {
    if (filter.duration?.from && filter.duration?.to) {
      setStartEndDate({
        start: new Date(filter.duration?.from),
        end: new Date(filter.duration?.to),
      })
    }
  }, [])

  return (
    <div>
      <FilterBoxHeader
        canShowClear={false}
        handleClearFilter={(): void => undefined}
        handleCollabseFilterBox={(): void => setIsCollapsed(!isCollapsed)}
        isCollapsed={isCollapsed}
        title="date_picker_duration"
      />
      <Spacer height={16} />
      <ViewedComponent available={!isCollapsed}>
        <DatePicker
          startDate={startEndDate?.start}
          endDate={startEndDate?.end}
          selectsRange
          onChange={handleChangeDate}
        />
      </ViewedComponent>
      <Spacer height={16} />
    </div>
  )
}

export default Duration
